import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useFormContext, Controller } from "react-hook-form";
import { useTheme } from '@material-ui/core/styles';

import * as RemindersApi from '../../../../../Common/Apis/RemindersApi';
import { IReminderType } from "../../../store/ReminderTypeStore";
import { useSpinner } from "../../../../../../core/contexts/SpinnerContext";



export interface Myoption { label: string; value: string; }

export const ReminderTypeList = () => {

  const { control, setValue } = useFormContext();

  const pageSzie = 200;
  const pageNo = 1;

  const [options, setOptions] = useState([{ label: "", value: "" }]);
  //const [options, setOptions] = useState();

  const { setSpinner } = useSpinner();

  const theme = useTheme();

  const colourStylesForSelect = {
    control: (styles: any, state: any) => ({
      ...styles,
      boxShadow: state.isFocused
        ? `0 0 0 0.1rem ${theme.palette.primary.main}4d`
        : 0,
      // boxShadow: `0 0 0 0.1rem ${theme.palette.primary.main}4d`,
      borderColor: state.isFocused ? theme.palette.primary.main : '#CED4DA',
      '&:hover': {
        borderColor: state.isFocused ? theme.palette.primary.main : '#CED4DA',
      },
    }),
  };

  useEffect(() => {
    getList(pageNo, pageSzie);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getList = async (_pageNo: number, _pageSize: number) => {

    setSpinner(true);
    try {

      const resData = await RemindersApi.getReminderTypeList(_pageNo, _pageSize);

      //console.log("resData.Data", resData.Data);

      resData.Data.sort(function (a: IReminderType, b: IReminderType) {
        if (a.Name.toLocaleLowerCase() < b.Name.toLocaleLowerCase()) {
          //console.log("1", a.Name.toLocaleLowerCase(), "--", b.Name.toLocaleLowerCase())
          return -1;
        }
        if (a.Name.toLocaleLowerCase() > b.Name.toLocaleLowerCase()) {
          //console.log("2", a.Name.toLocaleLowerCase(), "--", b.Name.toLocaleLowerCase())
          return 1;
        }
        return 0;
      });


      const dataOptions = resData.Data.map((reminderType: IReminderType) => (
        {
          label: reminderType.Name,
          value: reminderType.ReminderTypeId
        }
      ));

      setOptions(dataOptions);

      //console.log("resData", resData);

    } catch (err) {
      console.log('err', err);
    }
    setSpinner(false);
  };


  const handleChange = (data: any) => {
    if (data) {
      setValue("reminderType", data);
      setValue("reminderTypeId", data.value);
    }
    else {
      setValue("reminderType", "");
      setValue("reminderTypeId", "");
    }
  };

  return (


    <Controller
      name="reminderType"
      rules={{ required: true, validate: (v) => v.value !== "" }}
      control={control}
      render={({ field, }) =>
        <Select
          {...field}
          styles={colourStylesForSelect}
          isClearable
          options={options}
          onChange={handleChange}
        />}
    />
  );
};

